import Loadable from 'react-loadable'
import LoadingIndicatorFull from './LoadingIndicatorFull.js'

const LodableRouteProfile = Loadable({
  loader: () => import('./RouteProfileContainer.js'),
  loading: LoadingIndicatorFull,
})

export default LodableRouteProfile
